/* ============================================================
   Watch Reserves — "Notify me" pop-up for sold-out shop cards.

   Any [data-wr-notify-modal-open] (shop grid, search, homepage cards)
   opens one shared dialog filled from the trigger's data-variant,
   data-title and data-image, and registers the email with Klaviyo's
   back-in-stock subscription endpoint for that variant.

   Delegated from document: collection pages swap their grid on filter
   and load-more, so per-card listeners would go stale. On the homepage
   the trigger sits inside the card's <a>, so the click is cancelled
   before the browser follows the link.

   On success the email is also passed to Klaviyo's onsite identify
   (Oct 2026) so this browser's later activity lands on the profile.
   ============================================================ */
(function () {
  'use strict';

  var dialog = document.getElementById('wr-notify-modal');
  if (!dialog) return;

  var titleEl = dialog.querySelector('[data-wr-nmodal-title]');
  var imgEl = dialog.querySelector('[data-wr-nmodal-img]');
  var ask = dialog.querySelector('[data-wr-nmodal-ask]');
  var form = dialog.querySelector('[data-wr-nmodal-form]');
  var input = dialog.querySelector('#wr-nmodal-email');
  var submit = dialog.querySelector('[data-wr-nmodal-submit]');
  var note = dialog.querySelector('[data-wr-nmodal-note]');
  var variant = '';
  var busy = false;

  function say(message) {
    note.textContent = message || '';
    note.hidden = !message;
  }

  // Ties this browser to the email in Klaviyo; no-op if onsite JS is off.
  function identify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else {
        (window._learnq = window._learnq || []).push(['identify', { $email: email }]);
      }
    } catch (e) { /* not worth surfacing */ }
  }

  function open(trigger) {
    variant = trigger.dataset.variant || '';
    titleEl.textContent = trigger.dataset.title || '';
    var src = trigger.dataset.image || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    imgEl.src = src;
    imgEl.style.display = src ? '' : 'none';

    dialog.classList.remove('is-done');
    ask.hidden = false;
    say('');
    dialog.showModal();
    if (input) input.focus();
  }

  function fromEvent(e) {
    var trigger = e.target.closest('[data-wr-notify-modal-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open(trigger);
  }

  document.addEventListener('click', fromEvent, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    // Native buttons already turn these keys into clicks; the homepage
    // trigger is a span with role="button", so it needs this.
    if (e.target.matches && e.target.matches('span[data-wr-notify-modal-open]')) fromEvent(e);
  }, true);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy || !variant) return;

    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      say('Please enter a valid email address.');
      input.focus();
      return;
    }
    var honeypot = form.querySelector('input[name="company"]');
    if (honeypot && honeypot.value) return;

    busy = true;
    submit.disabled = true;
    say('');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + dialog.dataset.company, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } }
          }
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Klaviyo returned ' + r.status);
        identify(email);
        ask.hidden = true;
        dialog.classList.add('is-done');
        say("You're on the list. We'll email you if this piece returns.");
      })
      .catch(function () {
        say("That didn't go through. Please try again in a moment.");
      })
      .finally(function () {
        busy = false;
        submit.disabled = false;
      });
  });
})();
